module.exports = __webpack_public_path__ + "img/qycg.6fd73e0.jpg";